import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';

import { rootDraftsSaga } from '../../drafts/sagas/DraftsSagas';
import { rootPersonalSpaceSaga } from '../../personalSpace/sagas/PersonalSpaceSaga';
import { rootStartersSaga } from '../../starters/sagas/StartersSagas';
import { rootUploadContentSaga } from '../../uploadContent/sagas/UploadContentSaga';
import { rootUserNotificationSettingsSagas } from '../../userNotifications/redux/sagas/UserNotificationSettingsSaga';
import { rootUserNotificationSagas } from '../../userNotifications/redux/sagas/UserNotificationsSaga';
import { rootDisplayModeSaga } from './DisplayModeSaga';
import { rootRequestFailedSaga } from './RequestFailedSaga';
import { rootAvailableActionsForEntitySaga } from './spaces/AvailableActionsForEntitySagas';
import { rootSpacesSaga } from './spaces/RootSpacesSaga';
import { rootSiteSagas } from './spaces/SitesSagas';

export function* rootSaga(): SagaIterator {
  yield all([
    fork(rootDisplayModeSaga),
    fork(rootSpacesSaga),
    fork(rootRequestFailedSaga),
    fork(rootAvailableActionsForEntitySaga),
    fork(rootSiteSagas),
    fork(rootStartersSaga),
    fork(rootUploadContentSaga),
    fork(rootDraftsSaga),
    fork(rootUserNotificationSagas),
    fork(rootUserNotificationSettingsSagas),
    fork(rootPersonalSpaceSaga)
  ]);
}
